import React from "react";

export const timonelPublishedAt = (
  <span className="white">
    <i>Otra vez en Lilac</i> (1942) y <i>Cambam Bali</i> (1973)
  </span>
);
